import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labPharmacyListNewRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/pharmacy_lists/new',
}).lazy(() =>
  import('pages/lab/PharmacyLists/LabPharmacyListNewPage/LabPharmacyListNewPage').then(
    (d) => d.Route
  )
);
